import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import styles from "../../content/pages/homepage.module.css";
import { useEffect, useMemo } from "react";
import { Box } from "@mui/material";
import AllRankingsFilterToggle, { RankingsFilterValue } from "../AllRankings/AllRankingsFilterToggle";

interface PositionsButtonsRankingsProps {
  onSelectPosition: (position: string) => void;
  selectedPosition: string;
  selectedTimeframe: string;
  scrollToTop: () => void;
  isSeason: boolean;
  currentWeek: number;
  rankType: string;
  availablePositions: any[];
  selectedFilter?: RankingsFilterValue;
  onFilterChange?: (filter: RankingsFilterValue) => void;
  availableRankingsFilters?: RankingsFilterValue[];
  isPreseason?: boolean;
}

export default function PositionsButtonsRankings({
  onSelectPosition,
  selectedPosition,
  selectedTimeframe,
  scrollToTop,
  isSeason,
  // upcomingWeek,
  currentWeek,
  rankType,
  availablePositions,
  selectedFilter,
  onFilterChange,
  availableRankingsFilters,
  isPreseason = false,
}: PositionsButtonsRankingsProps) {
  // Week is added to the positions filters to allow for sorting by weekly rankings
  const mainFilters = useMemo(() => {
    if (rankType !== "current_week_fp") return ["Overall"];
    return ["Overall", "FP + ROS", "Week"];
  }, [rankType]);

  // Positions filters are the positions that are available for the rankings
  const positionsFilters = availablePositions || ["ALL", "QB", "RB", "WR", "TE"];

  // Check if current selection is a main filter or position filter
  const currentMainIndex = mainFilters.indexOf(selectedTimeframe);
  const currentPositionIndex = positionsFilters.indexOf(selectedPosition);

  const handleMainFilterClick = (index, filter) => {
    onSelectPosition(filter);
    // wait for the DOM to update for the scrollToTop to work for some devices
    setTimeout(() => {
      scrollToTop();
    }, 100);
  };

  const handlePositionClick = (index, position) => {
    if (position === "ALL") {
      onSelectPosition("ALL"); // Render all players
      // } else if (position === "DEF") {
      //   onSelectPosition("DEF"); // Render DEF players
    } else {
      onSelectPosition(position); // Render players selected position
    }
    // wait for the DOM to update for the scrollToTop to work for some devices
    setTimeout(() => {
      scrollToTop();
    }, 100);
  };

  return (
    <>
      <Box sx={{ maxWidth: "300px", margin: "auto" }}>
        {/* Show main filters if its a season, else show nothing */}
        {/* {isSeason && ( */}
        {mainFilters.length > 0 && (
          <Grid container spacing={0.5}>
            {mainFilters.map((filter, index) => (
              <Grid item xs key={filter}>
                <Button
                  fullWidth
                  variant="contained"
                  color={currentMainIndex === index ? "primary" : "inherit"}
                  onClick={() => handleMainFilterClick(index, filter)}
                  className={styles.positionButtonHover}
                  style={{ borderRadius: "5px", padding: "0px 2px", minWidth: "20px", height: "25px" }}
                >
                  {filter === "Week"
                    ? isPreseason
                      ? "Preseason"
                      : currentWeek
                        ? `Week ${currentWeek}`
                        : filter
                    : filter}
                </Button>
              </Grid>
            ))}
          </Grid>
        )}

        {/* All Rankings Filter Toggle */}
        <AllRankingsFilterToggle
          selectedFilter={selectedFilter}
          onFilterChange={onFilterChange}
          availableFilters={availableRankingsFilters}
        />

        {/* Positions Buttons */}
        <Grid container spacing={0.5} sx={{ pt: 0.5 }}>
          {positionsFilters.map((position, index) => (
            <Grid item xs key={position}>
              <Button
                fullWidth
                variant="contained"
                color={currentPositionIndex === index ? "primary" : "inherit"}
                onClick={() => handlePositionClick(index, position)}
                className={styles.positionButtonHover}
                style={{ borderRadius: "5px", padding: "0px 2px", minWidth: "20px", height: "25px" }}
              >
                {position}
              </Button>
            </Grid>
          ))}
        </Grid>
      </Box>
    </>
  );
}
